import { GraphQLClient } from "graphql-request";
import * as yieldFarming from "../generated/yield.sdk";
import { lazyInit } from "./utils";
export const yieldGraphqlClient = lazyInit(async () => new GraphQLClient(window.__ENV_CONFIG.apiUrls.yield));
export const getYieldSdk = lazyInit(() => yieldGraphqlClient().then(yieldFarming.getSdk));
//# sourceMappingURL=yield.js.map